import Mark from 'mark.js';
import { PdfViewerEventType } from '../+types/pdf-viewer-event.type';
import { PdfViewerPageEventType } from '../components/pdf-viewer-page/pdf-viewer-page-events.type';
import { PdfViewerPageLayer } from '../components/pdf-viewer-page/pdf-viewer-page.component.type';
import { RenderState } from '../../../types/RenderState.type';
export class PdfViewerPageHighlightService {
    constructor(eventBus, searchService, pagesByPageNumber) {
        this.eventBus = eventBus;
        this.searchService = searchService;
        this.pagesByPageNumber = pagesByPageNumber;
        this.options = {
            acrossElements: true,
            separateWordSearch: false,
            className: 'mark-highlight'
        };
        // Should be map keyed by pageNumber...
        this.markByPageNumber = new Map();
        this.onPdfViewerInitializeSearchEvent = () => {
            this.deleteMarks();
        };
        this.onPdfViewerPageLayerRenderStateChangeEvent = (event) => {
            const { layer, pageNumber, renderState } = event.payload;
            if (layer === PdfViewerPageLayer.PdfText &&
                renderState === RenderState.Finished &&
                this.searchService.searchState.pages.indexOf(pageNumber) !== -1) {
                this.mark(pageNumber, this.searchService.searchState.text);
            }
        };
        this.onPdfViewerFetchSearchResultsEvent = (event) => {
            event.payload.pages.forEach(pageNumber => this.mark(pageNumber, event.payload.text));
        };
        this.onPdfViewerPageResetEvent = (event) => {
            this.deleteMark(event.payload.pageNumber);
        };
        this.addEventListeners();
        window.PdfViewerPageHighlightService = this;
    }
    addEventListeners() {
        this.eventBus.on(PdfViewerEventType.InitializeSearch, this.onPdfViewerInitializeSearchEvent);
        this.eventBus.on(PdfViewerPageEventType.LayerRenderStateChange, this.onPdfViewerPageLayerRenderStateChangeEvent);
        this.eventBus.on(PdfViewerEventType.FetchSearchResults, this.onPdfViewerFetchSearchResultsEvent);
        this.eventBus.on(PdfViewerPageEventType.Reset, this.onPdfViewerPageResetEvent);
    }
    removeEventListeners() {
        this.eventBus.off(PdfViewerEventType.InitializeSearch, this.onPdfViewerInitializeSearchEvent);
        this.eventBus.off(PdfViewerPageEventType.LayerRenderStateChange, this.onPdfViewerPageLayerRenderStateChangeEvent);
        this.eventBus.off(PdfViewerEventType.FetchSearchResults, this.onPdfViewerFetchSearchResultsEvent);
        this.eventBus.off(PdfViewerPageEventType.Reset, this.onPdfViewerPageResetEvent);
    }
    getPdfViewerPagePdfTextLayerElement(pageNumber) {
        const pdfViewerPage = this.pagesByPageNumber.get(pageNumber);
        return pdfViewerPage === null || pdfViewerPage === void 0 ? void 0 : pdfViewerPage.pdfTextLayerElement;
    }
    mark(pageNumber, text) {
        const pdfTextLayerElement = this.getPdfViewerPagePdfTextLayerElement(pageNumber);
        if (pdfTextLayerElement) {
            const mark = new Mark(pdfTextLayerElement).mark(text, this.options);
            this.markByPageNumber.set(pageNumber, mark);
        }
    }
    deleteMark(pageNumber) {
        const mark = this.markByPageNumber.get(pageNumber);
        if (mark) {
            mark.unmark();
            this.markByPageNumber.delete(pageNumber);
        }
    }
    deleteMarks() {
        this.markByPageNumber.forEach(mark => mark.unmark());
        this.markByPageNumber = new Map();
    }
    destroy() {
        this.removeEventListeners();
        this.deleteMarks();
    }
}
//# sourceMappingURL=pdf-viewer-page-highlight.service.js.map